import { render, staticRenderFns } from "./Binnacle.vue?vue&type=template&id=6b85cfb4&"
import script from "./Binnacle.vue?vue&type=script&lang=js&"
export * from "./Binnacle.vue?vue&type=script&lang=js&"
import style0 from "./Binnacle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b85cfb4')) {
      api.createRecord('6b85cfb4', component.options)
    } else {
      api.reload('6b85cfb4', component.options)
    }
    module.hot.accept("./Binnacle.vue?vue&type=template&id=6b85cfb4&", function () {
      api.rerender('6b85cfb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/components/trays/managementTray/informationFlow/Binnacle.vue"
export default component.exports